import type { ViewSessionsQueryType } from "@/types/graphql/site.generated";

/** Код отказа лимита параллельных просмотров (Content.access, createView). */
export const PARALLEL_LIMIT_ERROR =
  "CONTENT_IS_NOT_AVAILABLE_BY_PARALLEL_LIMIT";

export type ViewSessionNode =
  ViewSessionsQueryType["viewSessions"]["nodes"][number];

/**
 * Ошибка createView или takeOverViewSession из-за лимита устройств:
 * бэкенд кладёт код в message GraphQL-ошибки (CodedError FORBIDDEN).
 */
export function isParallelLimitError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const graphQLErrors = (error as { graphQLErrors?: { message?: string }[] })
    .graphQLErrors;
  if (graphQLErrors?.some((item) => item.message === PARALLEL_LIMIT_ERROR)) {
    return true;
  }
  return (error as { message?: string }).message === PARALLEL_LIMIT_ERROR;
}

/**
 * Какие сеансы закрыть по умолчанию: самый давний чужой (спека
 * parallel-view-limit, «по умолчанию выбран самый давний сеанс»). Сеанс
 * этого браузера не закрывается.
 */
export function defaultCloseIds(nodes: readonly ViewSessionNode[]): string[] {
  const others = nodes
    .filter((node) => !node.isCurrentDevice)
    .sort(
      (a, b) =>
        new Date(a.lastSeenAt).getTime() - new Date(b.lastSeenAt).getTime(),
    );
  return others[0] ? [others[0].id] : [];
}

/** Подпись устройства: ОС и браузер, без них null (подставится «Неизвестное»). */
export function deviceTitle(node: ViewSessionNode): string | null {
  const parts = [node.userDeviceOs, node.userDeviceBrowser].filter(
    (part): part is string => Boolean(part) && part !== "Unknown",
  );
  return parts.length > 0 ? parts.join(" · ") : null;
}

export type DeviceKind = "phone" | "tv" | "computer";

/** Иконка по типу устройства из userAgent (normalizeDeviceType бэкенда). */
export function deviceKind(type: string | null | undefined): DeviceKind {
  if (type === "Mobile" || type === "Tablet") return "phone";
  if (type === "Smart TV" || type === "STB") return "tv";
  return "computer";
}
